import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function slideScroll() {
  const listWrapperEl = document.querySelector('.js-side-scroll-list-wrapper');
  const listEl = document.querySelector('.js-side-scroll-list');

  if (!listWrapperEl || !listEl) return;

  // ✅ スマホ（768px以下）の場合はアニメーション無効
  if (window.innerWidth <= 768) {
    return;
  }

  const startValue = 'top+=180px top';

  gsap.to(listEl, {
    x: () => -(listEl.clientWidth - listWrapperEl.clientWidth),
    ease: 'none',
    scrollTrigger: {
      trigger: '.js-side-scroll',
      start: startValue,
      end: () => `+=${listEl.clientWidth - listWrapperEl.clientWidth}`,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      // markers: true,
    },
  });

  ScrollTrigger.refresh();
}
